/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg width="8" height="12" viewBox="0 0 8 12" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  
  <polygon points=".021 11.222 .726 11.931 6.683 6.003 .709 0 0 .705 5.269 6" className="icon-fill"/>
</svg>

    )
  }
}

Icon.displayName = 'ChevronRightIcon'

export default Icon
